export const round = (number, places = 2) => {
  const decimals = 10 ** places;
  return Math.round(Number(number) * decimals) / decimals;
};

export const isBetween = (value, min, max) => max >= value && value >= min;
